export default "__VITE_ASSET__Dy$PIgel__"